import React, { lazy, Suspense } from 'react'

import CenteredLoader from 'components/Loader/CenteredLoader'
import { useIsNewLayout } from 'containers/App/NewLayout/useIsNewLayout'
import OldPaymentMethodsPage from 'containers/PaymentMethodsPage/Loadable'

const PaymentMethods = lazy(() => import(/* webpackChunkName: "PaymentMethodsPage" */ './'))

export default function LoadablePaymentMethodsPage() {
  const isNewLayout = useIsNewLayout()

  if (isNewLayout) {
    return (
      <Suspense fallback={<Loader />}>
        <PaymentMethods />
      </Suspense>
    )
  }

  return <OldPaymentMethodsPage />
}

function Loader() {
  return (
    <div style={{ minHeight: 500 }}>
      <CenteredLoader />
    </div>
  )
}
